import { render, staticRenderFns } from "./ParticipantEditCard.vue?vue&type=template&id=30e4a572&"
import script from "./ParticipantEditCard.vue?vue&type=script&lang=js&"
export * from "./ParticipantEditCard.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantEditCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports